import hdrm from '../../hdrm';
import elementMatchesSelector from '../verifiers/element-matches-selector';
import events from '../constants/events';

const interruptReplaceElement = (eventData, action) => {
  const { targetElementId: elementId, element } = action.payload;

  switch (eventData.action) {
    case events.DELETE_ELEMENT: {
      const elementToDelete = hdrm.accessors.getStaticElement(elementId);
      return elementMatchesSelector(elementToDelete, eventData.options.selector) ? {} : null;
    }

    case events.INSERT_ELEMENT: {
      return elementMatchesSelector(element, eventData.options.selector) ? {} : null;
    }

    default:
      return null;
  }
};

export default interruptReplaceElement;
